export default "__VITE_ASSET__C5wBZt7b__"